<template>
  <div class="page-not-found">
    <h1>
      <span class="emoji">&#x1F645;</span> Page Not Found
      <span class="emoji">&#x1F616;</span>
    </h1>
  </div>
</template>
